import {Props_ContentCta} from "./ContentCta.props";
import {CompileMarkdown} from "../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler";

const SnippetContentCta = (props: Props_ContentCta) => {
    const { heading, text, link } = props;
    const baseClass = 'snippet-content-cta';
    
    return (
        <section className={`${baseClass}`}>
            <div className={`${baseClass}__heading-section`}>
                {heading?.content?.value && 
                    <h2 className={`${baseClass}__heading`}>
                        {heading.content.value}
                    </h2>
                }
            </div>
            <div className={`${baseClass}__content-section`}>
                <div className={`${baseClass}__content-container`}>
                    {text?.content?.value &&
                        CompileMarkdown(text?.content.value)
                    }
                    {link?.linkHref?.value &&
                        <a className={`${baseClass}__link`} href={link.linkHref.value}>
                            {link?.linkText?.value}
                        </a>
                    }
                </div>
            </div>
        </section>
    )
}

export default SnippetContentCta